class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.bodyClickListenerTimeout = null;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const detailsEl = event?.target
      ? event.target.closest('details')
      : this.detailsContainer;
    detailsEl.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    trapFocus(focusContainer, input || focusContainer);

    if (this.bodyClickListenerTimeout) clearTimeout(this.bodyClickListenerTimeout);
    // Attach after the current click finishes bubbling; otherwise the same click hits body and closes the modal.
    this.bodyClickListenerTimeout = setTimeout(() => {
      this.bodyClickListenerTimeout = null;
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);
  }

  /** Open from another control (e.g. sticky bottom nav). Must run synchronously inside the user click so the search input can receive focus. */
  openFromExternal() {
    if (this.isOpen()) return;
    this.open({ target: this.summaryToggle });
  }

  close(focusToggle = true) {
    if (this.bodyClickListenerTimeout) {
      clearTimeout(this.bodyClickListenerTimeout);
      this.bodyClickListenerTimeout = null;
    }
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
